/* AN: Postcards.
   Turning the cards over, the send sheet, the live "what they'll see" preview,
   and the send itself. The send fires a Klaviyo event; a Klaviyo flow does the
   emailing, so there is no server of ours in the way. */
(function () {
  function init(root) {
    if (!root || root.dataset.anReady === '1') return;
    root.dataset.anReady = '1';

    var sheet = document.querySelector('[data-an-pcm]');
    if (!sheet) return;

    var company = root.getAttribute('data-company');
    var metric = root.getAttribute('data-metric') || 'Sent Postcard';
    var gcBase = root.getAttribute('data-giftcard') || '/pages/gift-cards';

    var q = function (s, scope) { return (scope || sheet).querySelector(s); };
    var current = null;          /* {design, name, front, back} */
    var pvSide = 'front';
    var lastFocus = null;

    /* --- turning a card over on the grid -------------------------------- */
    Array.prototype.slice.call(root.querySelectorAll('[data-an-pc-card]')).forEach(function (card) {
      card.addEventListener('click', function () {
        var front = card.querySelector('.an-pc__face--front');
        var back = card.querySelector('.an-pc__face--back');
        if (!front || !back) return;
        var showBack = front.hidden === false;
        front.hidden = showBack;
        back.hidden = !showBack;
        card.classList.toggle('is-back', showBack);
      });
    });

    /* --- ?card=handle, the link the postcard email sends them back on ----
       Email clients will not do the flip, so the email links here instead.
       Open that card on its back, and put it in view. */
    (function () {
      var wanted;
      try { wanted = new URLSearchParams(window.location.search).get('card'); } catch (e) { return; }
      if (!wanted) return;
      var card = root.querySelector('[data-an-pc-card][data-design="' + wanted.replace(/"/g, '') + '"]');
      if (!card) return;
      var front = card.querySelector('.an-pc__face--front');
      var back = card.querySelector('.an-pc__face--back');
      if (front && back) {
        front.hidden = true;
        back.hidden = false;
        card.classList.add('is-back');
      }
      try { card.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { card.scrollIntoView(); }
    }());

    /* --- land tabs -------------------------------------------------------
       Filtering happens in the page, not the server, because the whole set is
       already here and a round trip to show six fewer cards is a poor trade.
       The URL carries the choice so the land pages can link straight in. */
    (function () {
      var bar = document.querySelector('[data-an-pc-filters]');
      if (!bar) return;
      var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-an-pc-chip]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-an-pc-item]'));
      var row = bar.querySelector('[data-an-pc-filterrow]');
      var titleEl = bar.querySelector('[data-an-pc-filtertitle]');
      var countEl = bar.querySelector('[data-an-pc-filtercount]');
      var clear = bar.querySelector('[data-an-pc-clear]');
      var tpl = bar.getAttribute('data-title') || 'Postcards from [land]';

      function norm(v) { return (v || '').trim().toLowerCase(); }

      function apply(land, push) {
        var want = norm(land), shown = 0;
        items.forEach(function (it) {
          var hit = !want || norm(it.getAttribute('data-land')) === want;
          it.hidden = !hit;
          if (hit) shown++;
        });
        chips.forEach(function (c) {
          var on = norm(c.getAttribute('data-an-pc-chip')) === want;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (row) {
          row.hidden = !want;
          if (want) {
            var label = '';
            chips.some(function (c) {
              if (norm(c.getAttribute('data-an-pc-chip')) === want) { label = c.textContent.trim(); return true; }
            });
            titleEl.textContent = tpl.replace('[land]', label);
            countEl.textContent = shown + (shown === 1 ? ' postcard' : ' postcards');
          }
        }
        if (push) {
          try {
            var u = new URL(window.location.href);
            if (want) u.searchParams.set('land', land); else u.searchParams.delete('land');
            history.replaceState(null, '', u);
          } catch (e) {}
        }
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () { apply(c.getAttribute('data-an-pc-chip'), true); });
      });
      if (clear) clear.addEventListener('click', function () { apply('', true); });

      var start = '';
      try { start = new URLSearchParams(window.location.search).get('land') || ''; } catch (e) {}
      if (start) apply(start, false);
    }());

    /* --- the sheet ------------------------------------------------------ */
    function cardsOnPage() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-an-pc-send]')).map(function (b) {
        return {
          design: b.getAttribute('data-design'),
          name: b.getAttribute('data-name'),
          front: b.getAttribute('data-front'),
          back: b.getAttribute('data-back')
        };
      });
    }

    function open(card) {
      current = card;
      pvSide = 'front';
      lastFocus = document.activeElement;

      q('[data-an-pcm-form]').hidden = false;
      q('[data-an-pcm-done]').hidden = true;
      hideErrors();
      step('write');

      var thumb = q('[data-an-pcm-thumb]');
      thumb.src = card.front; thumb.alt = card.name;
      q('[data-an-pcm-name]').textContent = card.name;

      var link = q('[data-an-pcm-gclink]');
      if (link) link.href = gcBase + (gcBase.indexOf('?') > -1 ? '&' : '?') + 'design=' + encodeURIComponent(card.design);

      var turn = q('[data-an-pcm-turn]');
      turn.hidden = !card.back;
      turn.textContent = 'Turn over';

      paint();
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = q('[data-an-pcm-msg]');
      if (first) first.focus();
    }

    function close() {
      sheet.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function val(sel) { var el = q(sel); return el ? el.value.trim() : ''; }

    function stepEl(name) { return sheet.querySelector('[data-an-pcm-step="' + name + '"]'); }

    function hideErrors() {
      ['[data-an-pcm-err]', '[data-an-pcm-err2]'].forEach(function (sel) {
        var el = q(sel); if (el) el.hidden = true;
      });
    }

    function step(name) {
      ['write', 'preview'].forEach(function (n) {
        var el = stepEl(n);
        if (el) el.hidden = n !== name;
      });
      if (name === 'preview') paint();
    }

    function paint() {
      if (!current) return;
      var to = val('[data-an-pcm-to]');
      var from = val('[data-an-pcm-from]');
      var msg = val('[data-an-pcm-msg]');

      var pvTo = q('[data-an-pcm-pvto]');
      if (pvTo) pvTo.textContent = val('[data-an-pcm-email]') || 'their email';
      q('[data-an-pcm-subject]').textContent = (from || 'Someone') + ' sent you a postcard';
      q('[data-an-pcm-pvgreeting]').textContent = 'Dear ' + (to || 'friend') + ',';
      q('[data-an-pcm-pvmsg]').textContent = msg;
      q('[data-an-pcm-pvsign]').textContent = 'Love, ' + (from || 'me');

      var img = q('[data-an-pcm-pvimg]');
      img.src = pvSide === 'back' && current.back ? current.back : current.front;
      img.alt = current.name;
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-an-pc-send]')).forEach(function (b) {
      b.addEventListener('click', function () {
        open({
          design: b.getAttribute('data-design'),
          name: b.getAttribute('data-name'),
          front: b.getAttribute('data-front'),
          back: b.getAttribute('data-back')
        });
      });
    });

    Array.prototype.slice.call(sheet.querySelectorAll('[data-an-pcm-close]')).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });

    ['[data-an-pcm-to]', '[data-an-pcm-from]', '[data-an-pcm-msg]'].forEach(function (sel) {
      var el = q(sel);
      if (el) el.addEventListener('input', paint);
    });

    var toPreview = q('[data-an-pcm-topreview]');
    if (toPreview) toPreview.addEventListener('click', function () {
      var form = q('[data-an-pcm-form]');
      /* Check only the write step: the browser will not report on fields it
         cannot see, and the preview step has none to check anyway. */
      var fields = Array.prototype.slice.call(stepEl('write').querySelectorAll('input, textarea'));
      var bad = fields.filter(function (f) { return !f.checkValidity(); })[0];
      if (bad) { bad.reportValidity(); return; }
      hideErrors();
      pvSide = 'front';
      if (turnBtn) turnBtn.textContent = 'Turn over';
      step('preview');
      var box = sheet.querySelector('.an-pcm__box');
      if (box) box.scrollTop = 0;
    });

    var newsBox = q('[data-an-pcm-news]');
    if (newsBox) newsBox.addEventListener('change', function () {
      var field = q('[data-an-pcm-newsemail]');
      if (!field) return;
      field.hidden = !newsBox.checked;
      field.required = newsBox.checked;
      if (newsBox.checked) field.focus();
    });

    var editBtn = q('[data-an-pcm-edit]');
    if (editBtn) editBtn.addEventListener('click', function () {
      hideErrors();
      step('write');
      var m = q('[data-an-pcm-msg]'); if (m) m.focus();
    });

    var turnBtn = q('[data-an-pcm-turn]');
    if (turnBtn) turnBtn.addEventListener('click', function () {
      pvSide = pvSide === 'front' ? 'back' : 'front';
      turnBtn.textContent = pvSide === 'front' ? 'Turn over' : 'Turn back';
      paint();
    });

    /* --- sending -------------------------------------------------------- */
    q('[data-an-pcm-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) return;

      var to = val('[data-an-pcm-to]');
      var from = val('[data-an-pcm-from]');
      var email = val('[data-an-pcm-email]');
      var msg = val('[data-an-pcm-msg]');
      var go = stepEl('preview').querySelector('[data-an-pcm-go]');
      var err = q('[data-an-pcm-err2]') || q('[data-an-pcm-err]');

      if (!company) { err.textContent = 'Sending is not set up yet.'; err.hidden = false; return; }
      go.disabled = true;

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: metric } } },
              properties: {
                'Postcard': current.name,
                'Postcard handle': current.design,
                'Postcard image': current.front,
                'To name': to,
                'From name': from,
                'Message': msg,
                'Sent from': location.href
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, first_name: to }
                }
              }
            }
          }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('klaviyo ' + r.status);
        subscribeSender();
        done(to);
      }).catch(function () {
        go.disabled = false;
        err.textContent = 'That did not go through. Please try again.';
        err.hidden = false;
      });
    });

    /* The tick signs up whoever is sending, never the person receiving. Their
       address is a separate field that only appears once the box is ticked, so
       nobody hands over an email they did not mean to. A failure here is
       deliberately silent: the postcard has already gone, and a newsletter
       that did not take is not the sender's problem to solve mid-flow. */
    function subscribeSender() {
      var box = q('[data-an-pcm-news]');
      if (!box || !box.checked) return;
      var listId = root.getAttribute('data-news-list');
      var email = val('[data-an-pcm-newsemail]');
      if (!listId || !email || !company) return;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Postcards page',
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).catch(function () {});
    }

    function done(to) {
      q('[data-an-pcm-form]').hidden = true;
      var panel = q('[data-an-pcm-done]');
      panel.hidden = false;
      q('[data-an-pcm-donetitle]').textContent = 'Your postcard is on its way to ' + to + '.';

      /* Three others to send next, never the one just sent. */
      var others = cardsOnPage().filter(function (c) { return c.design !== current.design; }).slice(0, 3);
      var wrap = q('[data-an-pcm-again]');
      wrap.innerHTML = '';
      others.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'an-pcm__againcard';
        b.innerHTML = '<span class="an-pcm__againthumb"><img src="' + c.front + '" alt=""></span>' +
                      '<span class="an-pcm__againname"></span>';
        b.querySelector('.an-pcm__againname').textContent = c.name;
        b.addEventListener('click', function () {
          q('[data-an-pcm-msg]').value = '';
          open(c);
        });
        wrap.appendChild(b);
      });
    }
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-an-pc]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
